import * as tslib_1 from "tslib";
import { ChangeDetectorRef, EventEmitter, OnInit, ViewContainerRef } from '@angular/core';
import { BooleanConverter } from '../../../inputConverter';
import { ImportService } from '../../../services/import.service';
import { BaseComponent } from '../../base.component';
var ImportShapefileComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ImportShapefileComponent, _super);
    function ImportShapefileComponent(_vcr, importService, cdr) {
        var _this = _super.call(this, _vcr, true) || this;
        _this.importService = importService;
        _this.cdr = cdr;
        _this._enableMapFileDrop = true;
        _this.onfiledrop = new EventEmitter();
        _this.onfiledone = new EventEmitter();
        _this.ondragenter = function (e) {
            var shapefiles = Array.from(e.dataTransfer.items).filter(function (x) { return x.type === 'application/x-zip-compressed'; });
            if (shapefiles.length) {
                e.preventDefault();
                _this.showMapDropOverlay(true);
            }
        };
        _this.ondragover = function (e) {
            e.preventDefault();
        };
        _this.ondrop = function (e) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        e.preventDefault();
                        this.showMapDropOverlay(false);
                        this.onfiledrop.emit(e);
                        return [4 /*yield*/, this.importService.importFiles(e)];
                    case 1:
                        _a.sent();
                        this.onfiledone.emit(e);
                        return [2 /*return*/];
                }
            });
        }); };
        _this.hideOverlay = function () {
            _this.showMapDropOverlay(false);
        };
        _this.registerEvent('onfiledrop', _this.onfiledrop);
        _this.registerEvent('onfiledone', _this.onfiledone);
        return _this;
    }
    Object.defineProperty(ImportShapefileComponent.prototype, "enableMapFileDrop", {
        get: function () {
            return this._enableMapFileDrop;
        },
        set: function (value) {
            this._enableMapFileDrop = BooleanConverter(value);
            if (this._enableMapFileDrop) {
                this.setDefaultDropElement();
            }
            else {
                this.removeMapDropEvents();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ImportShapefileComponent.prototype, "loading", {
        get: function () {
            return this.importService.loading;
        },
        enumerable: true,
        configurable: true
    });
    ImportShapefileComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.enableMapFileDrop) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.setDefaultDropElement()];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2:
                        _a = this;
                        return [4 /*yield*/, this.setupMapViewRef(this.mapView)];
                    case 3:
                        _a.mapView = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ImportShapefileComponent.prototype.setDefaultDropElement = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var parent_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.dropElement) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.getClosestAncestor('mc-map')];
                    case 1:
                        parent_1 = _a.sent();
                        if (!parent_1) return [3 /*break*/, 3];
                        return [4 /*yield*/, parent_1.ready];
                    case 2:
                        _a.sent();
                        this.dropElement = parent_1.mapView.container;
                        _a.label = 3;
                    case 3:
                        this.setupMapDropEvents();
                        return [2 /*return*/];
                }
            });
        });
    };
    ImportShapefileComponent.prototype.setupMapDropEvents = function () {
        this.dropElement.addEventListener('dragenter', this.ondragenter);
        this.dropElement.addEventListener('drop', this.ondrop);
        this.dropElement.addEventListener('mouseover', this.hideOverlay);
        this.dropElement.addEventListener('dragend', this.hideOverlay);
        this.dropElement.addEventListener('dragleave', this.hideOverlay);
        this.dropElement.addEventListener('click', this.hideOverlay);
        this.dropElement.addEventListener('dragover', this.ondragover);
    };
    ImportShapefileComponent.prototype.removeMapDropEvents = function () {
        this.dropElement.removeEventListener('dragenter', this.ondragenter);
        this.dropElement.removeEventListener('drop', this.ondrop);
        this.dropElement.removeEventListener('mouseover', this.hideOverlay);
        this.dropElement.removeEventListener('dragend', this.hideOverlay);
        this.dropElement.removeEventListener('dragleave', this.hideOverlay);
        this.dropElement.removeEventListener('click', this.hideOverlay);
        this.dropElement.removeEventListener('dragover', this.ondragover);
    };
    ImportShapefileComponent.prototype.showMapDropOverlay = function (show) {
        if (show === void 0) { show = true; }
        this.dropElement.style.setProperty('opacity', show ? '0.7' : '1');
    };
    return ImportShapefileComponent;
}(BaseComponent));
export { ImportShapefileComponent };
